module.exports = __webpack_public_path__ + "img/banner-hen-en.a7a4e505.png";